///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export enum GtthManualDesignStepsEnum {
    DESIGN_P2MP,
    DESIGN_RINGS,
    AUTO_SET_FREQUENCIES
}
